import React from 'react';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import ImageLogoBox from '../boxes/ImageLogoBox';

const ImageOption = ({ src, alt, label, IconComponent, isMobile, ...props }) => (
  <Box
    component="li"
    {...props}
    display="grid"
    alignItems="center"
    gap={2}
  >
    <ImageLogoBox
      src={src}
      alt={alt}
      IconComponent={IconComponent}
      sx={{}}
      imgWidth={isMobile ? 48 : 60}
      imgHeight={isMobile ? 20 : 24}
    />
    <Typography variant={isMobile ? 'small_2' : 'medium_2'} color="gray.A500">
      {label}
    </Typography>
  </Box>
);

ImageOption.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  IconComponent: PropTypes.elementType,
  isMobile: PropTypes.bool,
};

ImageOption.defaultProps = {
  src: null,
  IconComponent: null,
  isMobile: false,
};

export default ImageOption;
